'use strict';

var App = require('app');
var I18N = require('utils/i18n');

var FeedbackCategory = Backbone.Model.extend({});

var FeedbackCategoryCollection = Backbone.Collection.extend({
    url: '/api/v1/feedback/categories',
    model: FeedbackCategory,
});

var API = {
    getCategories: function () {
        var defer = $.Deferred();
        var list = new FeedbackCategoryCollection();
        list.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    send: function (categoryID, text, copyToUser) {
        var defer = $.Deferred();

        var feedback = {
            local_time: new Date(),
            timezone: new Date().getTimezoneOffset() / 60,
            url: document.location.href,
            user_agent: navigator.userAgent,
            cookies_enabled: navigator.cookieEnabled,
            platform: navigator.platform,
            resolution: '' + screen.width + 'x' + screen.height,
            window: '' + $(window).width() + 'x' + $(window).height(),
            browser_language: navigator.language || navigator.userLanguage,
            app_language: I18N.language,
        };

        feedback.text = text;
        feedback.category = parseInt(categoryID);
        feedback.copy_to_user = copyToUser;

        App.ajax({
            url: 'api/v1/feedback',
            method: 'POST',
            data: JSON.stringify(feedback),
            success: function () {
                defer.resolve(true);
            },
            error: function () {
                defer.resolve(false);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('feedback:categories', function () {
    return API.getCategories();
});

App.reqres.setHandler('feedback:send', function (categoryID, text, copyToUser) {
    return API.send(categoryID, text, copyToUser);
});
